export const selectToken = state => state.userReducer.token;

export const selectUserName = state => state.userReducer.name;

export const selectUserEmail = state => state.userReducer.email;

export const selectUserId = state => state.userReducer.id;

export const selectUserAge = state => state.userReducer.age;